import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';
import { CustomerSearchResult } from './core/models/customer-search-result';
import { AppointmentModel } from './core/models/appointment-model';
import { FindTimeResultItem } from './core/models/find-time-result-item-model';
import { Arguments } from './core/models/arguments';
import { ColorLabel } from './core/interfaces/color-label';
import { TerminologyItem } from './core/interfaces/terminology-item';
import { Patient } from './core/interfaces/patient';
import { CancelReason } from './core/interfaces/cancel-reason';




@Injectable()
export class AppSettings {
    public settings = new Settings(
        '', // name,
        true, // headerVisible
        true, // loadingSpinner
        true, //showHeaderButtons,
        true, // rtl
        'he', // locale        
        0 // firstDayOfWekk

    );
}


